import { cn } from '@nucleus-commerce/ui/lib/utils';

import type { HttpMethod } from '../generated/reference';

const tone: Record<HttpMethod, string> = {
  GET: 'bg-info/10 text-info border-info/25',
  POST: 'bg-success/10 text-success border-success/25',
  PUT: 'bg-warning/15 text-warning-foreground border-warning/40 dark:text-warning',
  PATCH: 'bg-warning/15 text-warning-foreground border-warning/40 dark:text-warning',
  DELETE: 'bg-destructive/10 text-destructive border-destructive/25',
};

/** HTTP method chip used in the sidebar, the reference index and endpoint headers. */
export function MethodBadge({
  method,
  size = 'sm',
  className,
}: {
  method: HttpMethod;
  size?: 'xs' | 'sm';
  className?: string;
}) {
  return (
    <span
      data-method={method}
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded border font-mono font-semibold tracking-tight uppercase',
        size === 'xs' ? 'h-4 min-w-10 px-1 text-[10px]' : 'h-5 min-w-12 px-1.5 text-[11px]',
        tone[method],
        className,
      )}
    >
      {method === 'DELETE' ? 'DEL' : method}
    </span>
  );
}
